var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.84,
    height: 24.515,
    viewBox: "0 0 28.84 24.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M92.245,53.07H90a5.813,5.813,0,0,1,.352,2v8.449a2.494,2.494,0,0,1-.145.835H93.9a2.494,2.494,0,0,0,2.494-2.494V57.24A4.177,4.177,0,0,0,92.245,53.07Z",
    transform: "translate(-67.555 -39.835)",
    fill: "#53a245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M40.077,44.35H34.972A4.177,4.177,0,0,0,30.8,48.522v8.447a.835.835,0,0,0,.835.835H43.419a.835.835,0,0,0,.835-.835V48.522A4.177,4.177,0,0,0,40.077,44.35Z",
    transform: "translate(-23.119 -33.289)",
    fill: "#53a245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M42.683,0A5.015,5.015,0,1,0,47.7,5.017,5.015,5.015,0,0,0,42.683,0Z",
    transform: "translate(-28.275)",
    fill: "#53a245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M81.841,18.75a3.741,3.741,0,1,0,3.741,3.741A3.741,3.741,0,0,0,81.841,18.75Z",
    transform: "translate(-58.623 -14.074)",
    fill: "#53a245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M4.172,53.07H6.417a5.813,5.813,0,0,0-.352,2v8.449a2.494,2.494,0,0,0,.145.835H2.494A2.494,2.494,0,0,1,0,61.856V57.24a4.177,4.177,0,0,1,4.172-4.17Z",
    transform: "translate(0 -39.835)",
    fill: "#53a245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M11.351,18.75A3.741,3.741,0,1,1,7.61,22.491a3.741,3.741,0,0,1,3.741-3.741Z",
    transform: "translate(-5.712 -14.074)",
    fill: "#53a245"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.f5fe6cd2aa75f1aee4b4921028b6ae98.svg";
export { ForwardRef as ReactComponent };